import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import { usePraxis } from "../context/PraxisContext";

const mdComponents = {
  a: ({ node, ...props }) => (
    <a
      {...props}
      target={props.href?.startsWith("http") ? "_blank" : undefined}
      rel={props.href?.startsWith("http") ? "noopener noreferrer" : undefined}
    />
  ),
};

export default function Impressum() {
  const { effectiveImpressum } = usePraxis();
  return (
    <div className="legal-page" data-testid="impressum-page">
      <p className="section-label">Rechtliches</p>
      <h1>Impressum</h1>
      <div className="legal-md">
        <ReactMarkdown remarkPlugins={[remarkBreaks]} components={mdComponents}>
          {effectiveImpressum}
        </ReactMarkdown>
      </div>
    </div>
  );
}
